export default {
    GET_NODETOKEN_BY_NODE: 'getNodeTokenByNode',
    GET_NODETOKEN_BY_NODE_AND_PARENTS: 'getNodeTokenByNodeAndParents',
    ADD_NODETOKEN: 'addNodeToken',
    DELETE_NODETOKEN: 'deleteNodeToken',
  }
  